import { FC } from 'react';
import { IHeaderLayout } from '.';
import PageTitle from './PageTitle';

const Header: FC<IHeaderLayout> = ({
  title,
  subTitle,
  actions,
}) => {
  return (
    <div className="lg:flex gap-8 lg:justify-between">   
      <div className="min-w-0 flex-1 gap-1 flex flex-col">
        <PageTitle>
          {title}
        </PageTitle>       
        {!!subTitle && (
          <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap text-text_pale sm:space-x-6">
            {subTitle}
          </div>
        )}
      </div>
      {!!subTitle && (
        <div className="mt-5 flex lg:ml-4 lg:mt-0 items-center">          
            <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
              {actions}
            </div>        
        </div>
      )}

    </div>
  );
}

export default Header;
